import { styled } from 'maple-storybook'

import { StyledTypography } from 'variables/styles/typographyStyle.jsx'

const Success = styled(({ children, ...rest }) => <div {...rest}>{children}</div>)(() => ({
  ...StyledTypography.successText,
  ...StyledTypography.defaultFontStyle
}))

export default Success
